import { Outlet } from "react-router-dom";

import TopBar from "../components/TopBar";
import LogoBar from "../components/LogoBar";
import NavMenu from "../components/NavMenu";

export default function MainLayout() {
    return (
        <>
            <TopBar />
            <LogoBar />
            <NavMenu />

            <main className="bg-gray-50">
                <Outlet />
            </main>
        </>
    );
}
